import CurrencySymbol from '@/util/currency';
import Image from 'next/image';
import type { ProductRoot } from '../types/product';

export const SezzleInfo = ({ product }: { product: ProductRoot }) => {
  const sezzlePrice = Math.floor((product.price.regularPrice.amount.value / 4) * 100) / 100;

  return (
    <p className='mt-2.5 flex flex-wrap items-center gap-x-2.5 lg_mt-0 lg_gap-x-[30px]'>
      <span className='text-sm leading-5'>
        <span>Or 4 interest-free payments of</span>
        <span className='ml-1.5'>
          {CurrencySymbol[product.price.regularPrice.amount.currency as keyof typeof CurrencySymbol]}
          {sezzlePrice}
        </span>
        <span>&nbsp;with</span>
      </span>
      <Image
        src={`${process.env.NEXT_PUBLIC_BASE_PATH}/Sezzle_Logo_FullColor.svg`}
        alt='sezzle'
        width={84}
        height={21}
        className=' inline h-auto w-[72px] align-top'
      />
    </p>
  );
};
